(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('ExplainDeliveryMethodService', ExplainDeliveryMethodService);

    ExplainDeliveryMethodService.$inject = ['$resource'];

    function ExplainDeliveryMethodService($resource) {
        var service = $resource('api/property/popup/:id/explain/deliveryMethod', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;

    }
})();
